module.exports = __webpack_public_path__ + "static/img/NZ3I1GXJC1.e2b1548.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/NZ3I1GXJC1.jpg
// module id = Pt1m
// module chunks = 1